<script lang="ts">
    import type { ColorSetting } from "..";

    export let setting: ColorSetting;

    function openPicker(e: Event) {
        const target = e.target as HTMLElement;
        (target.nextElementSibling as HTMLElement).click();
    }
</script>

<!----------------------------------------------------------------------------->

<button style="background: {setting.value};" on:click={openPicker}/>
<input type="color" bind:value={setting.value} />
<input id={setting.id} type="text" bind:value={setting.value} />

<!----------------------------------------------------------------------------->

<style>
    input[type="text"] {
        width: 20ch;
    }

    input[type="color"] {
        display: none;
    }

    button {
        all: unset;
        box-sizing: border-box;
        width: 1.75em;
        height: 1.75em;
        border: 1px solid var(--g400);

        &:hover {
            border-color: var(--gacc100);
            outline: 1px solid var(--gacc100);
        }

        &:active {
            border-color: var(--gacc200);
            outline: none;
        }
    }
</style>
